/**
 * Ce que vaut une photo de document, avant même de la lire.
 *
 * Une photo passée par une messagerie, ou floue, coûte plus à la lecture que
 * n'importe quel réglage du moteur : c'est le premier levier (plan OCR du
 * 07/10/2026, chantier A). Le service de lecture mesure ; cette règle dit
 * quoi en conclure. Elle n'empêche rien : la lecture se fait quand même, et
 * l'agent sait pourquoi elle est faible, et comment faire mieux.
 */
/**
 * Mesuré le 07/10/2026 : une photo de téléphone d'origine fait 4 080 px de
 * long ; la même, envoyée comme « photo » par une messagerie, 1 600 px.
 */
export const COTE_MIN_PRISE_DE_VUE = 2000;
/**
 * Mesuré le 07/10/2026 : photos lisibles 345 à 1 620 ; photos compressées
 * par une messagerie, 490 et 527 ; un flou léger (σ = 1) tombe à 50.
 */
export const NETTETE_MIN_PRISE_DE_VUE = 60;
export const DEFAUTS_PRISE_DE_VUE = ['REDUITE', 'FLOUE'];
/** Les défauts de chaque page. Une page mesurée à zéro n'a pas pu être ouverte : on n'en dit rien. */
export function defautsDePriseDeVue(pages) {
    const defauts = [];
    for (const p of pages) {
        if (p.largeur <= 0 || p.hauteur <= 0)
            continue;
        if (Math.max(p.largeur, p.hauteur) < COTE_MIN_PRISE_DE_VUE) {
            defauts.push({ page: p.page, defaut: 'REDUITE' });
        }
        if (p.nettete < NETTETE_MIN_PRISE_DE_VUE)
            defauts.push({ page: p.page, defaut: 'FLOUE' });
    }
    return defauts;
}
const pages = (liste) => liste.length === 1 ? `la page ${String(liste[0])}` : `les pages ${liste.join(', ')}`;
/** Le conseil à afficher, en une phrase par défaut ; `null` quand la photo est bonne. */
export function conseilDePriseDeVue(defauts) {
    const reduites = defauts.filter((d) => d.defaut === 'REDUITE').map((d) => d.page);
    const floues = defauts.filter((d) => d.defaut === 'FLOUE').map((d) => d.page);
    const phrases = [];
    if (reduites.length > 0) {
        phrases.push(`La photo est réduite (${pages(reduites)}) : une messagerie l’a sans doute compressée. Envoyez la photo d’origine, en fichier ou en « document », pas en « photo ».`);
    }
    if (floues.length > 0) {
        phrases.push(`La photo est floue (${pages(floues)}) : reprenez-la à plat, à la lumière du jour, sans bouger.`);
    }
    return phrases.length === 0 ? null : phrases.join(' ');
}
//# sourceMappingURL=prise-de-vue.js.map